import IncorrectAssetTypesAuditComponent from "../MusicAssetAuditComponents/IncorrectAssetTypesAudit";

const IncorrectAssetTypes = () => {
  return <IncorrectAssetTypesAuditComponent />;
};

export default IncorrectAssetTypes;
